import { Row, RowProps } from "react-bootstrap";

export function FormRow({ className, ...props }: Readonly<RowProps>) {
    return <Row className={`gx-4 ${className ?? ''}`} {...props} />;
}
